import React from "react";
import { HistoryCard, HistoryContainer, HistoryList } from "./History.styled";
import { useDispatch, useSelector } from "react-redux";
import { DATETIME_OPTIONS } from "../../constants";
import { useEffect } from "react";
import { getUserHistories } from "../../feature/history/HistoryActions";

const History = () => {
  const dispatch = useDispatch();
  const { userHistories } = useSelector((state) => state.history);
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    Object.keys(user).length && dispatch(getUserHistories({ user: user }));
  }, [dispatch, user]);
  

  return (
    <HistoryContainer>
      <HistoryCard>
        {userHistories &&
          userHistories.map((history, index, row) => (
            <HistoryList key={index}>
              <div
                style={{
                  marginBlockEnd: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {history.subject}
                <span>
                  {new Intl.DateTimeFormat("default", DATETIME_OPTIONS).format(
                    new Date(history.date)
                  )}
                </span>
              </div>
              <span>
                <span
                  style={{
                    color: `${
                      history.tx_type === "withdraw" ||
                      history.tx_type === "buy" ||
                      history.tx_type === "stake"
                        ? "#F0BCBC"
                        : "#30A81C"
                    }`,
                  }}
                >
                  {history.tx_type === "withdraw" ||
                  history.tx_type === "buy" ||
                  history.tx_type === "stake"
                    ? `-${history.amount}`
                    : `+${history.amount}`}{" "}
                  TRX
                </span>{" "}
                {history.message}
              </span>
            </HistoryList>
          ))}
      </HistoryCard>
    </HistoryContainer>
  );
};

export default History;
